import { useQuery } from "@tanstack/react-query"

import type { AgentWorkingStateFact } from "@/api/client/hosted-agents"

import { fetchAgentWorkingState } from "@/api/client/hosted-agents"
import { queryKeys } from "@/lib/query-keys"

/**
 * Active working-state facts for one agent (#3023): the structured values the
 * agent has established and a human has confirmed. Read-only in the user
 * surface — corrections happen in the admin wizard's Memory tab.
 */
export function useAgentWorkingState(slug: string | undefined) {
  return useQuery<AgentWorkingStateFact[]>({
    queryKey: queryKeys.hostedAgentWorkingState(slug ?? ""),
    queryFn: () => fetchAgentWorkingState(slug ?? ""),
    enabled: !!slug,
  })
}
